<template>
  <communication-item
    :type="type"
    :title="title"
    :date="date"
    icon="text"
    color="is-texts"
  >
    <template v-slot:subtext>
      <p
        v-if="text.is_scheduled"
        @click="cancelScheduledText"
        class="unschedule"
      >DON'T SEND THE TEXT</p>

      <p
        v-if="text.error_message"
        class="error-message"
      >
        {{ text.error_message }}
      </p>

      <p v-if="createdBy">{{ createdBy }}</p>
    </template>

    <b-checkbox
      v-if="isInbound"
      class="text_checkbox"
      size="is-small"
      @input="handleCheck($event, text.id)"
      type="is-success"
      :value="isAddressed"
      :disabled="isDisabled"
    >
      <template v-if="text.addressed_at">
        Addressed by <strong>{{ addressedByName }}</strong> on <strong>{{ addressedDate }}</strong>
      </template>
      <template v-else>Not addressed</template>
    </b-checkbox>

    <p class="white-space"><strong>Message:</strong> {{ text.text_message.replace(/<[^>]*>?/gm, '') }}</p>

    <template v-slot:column>
      <slot name="column"></slot>
    </template>
  </communication-item>
</template>

<script>
import CommunicationItem from "./CommunicationItem";
import {ENUMS} from "../../../services/enums";
import dates from "../../../services/dates";

export default {
  name: "CommunicationItemText",
  components: {CommunicationItem},
  props: {
    text: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      isDisabled: false,
    }
  },
  computed: {
    isAddressed() {
      return !!this.text.addressed_at;
    },
    addressedByName() {
      return this.$store.getters.users.find(user => user.id === this.text.addressed_by).full_name;
    },
    addressedDate() {
      return dates.formatAsDateTime(this.text.addressed_at);
    },
    isInbound() {
      return this.text.communication_direction === ENUMS.CommunicationDirectionEnum.Inbound.value;
    },
    type() {
      let suffix = ' Text';

      if(this.isInbound) {
        return 'Inbound' + suffix;
      } else if (this.text.is_scheduled) {
        return 'Scheduled' + suffix;
      } else {
        return 'Outbound' + suffix;
      }
    },
    title() {
      const contact = this.text.contact_number;
      const number = this.text.integration_label;

      if(this.isInbound) {
        return contact + ' > ' + number;
      } else {
        return number + ' > ' + contact;
      }
    },
    date() {
      if (this.text.scheduled_at) {
        return dates.formatAsDateTime(this.text.scheduled_at);
      }

      return dates.formatAsDateTime(this.text.created_at);
    },
    createdBy() {
      if (! this.text.createdBy.display_name) return null;

      if (this.text.communication_direction === ENUMS.CommunicationDirectionEnum.Outbound.value) {
        return `by ${this.text.createdBy.display_name}`;
      }

      return null;
    },
  },
  methods: {
    handleCheck(val, id) {
      const addressedBy = val ? this.$store.state.activeUser : null;

      this.isDisabled = true;

      this.$api.communicationLogs.setAddressed({ id, addressedBy }).then(() => {
        setTimeout(() => {
          this.isDisabled = false;
        }, 1000);
      });
    },
    cancelScheduledText() {
      this.$utils.confirm(
        `Are you sure you want to <strong>cancel</strong> the scheduled text?`,
        'Cancel Scheduled Text'
      )
        .then(() => {
          this.$api.communicationLogs.cancelSchedule(this.text.id).then(res => {})
        });
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.white-space {
  white-space: pre-line;
  word-break: break-all;
}

.unschedule {
  color: $primary;
  cursor: pointer;
}

.error-message {
  color: $red;
  text-transform: uppercase;
}

.text_checkbox {
  margin-bottom: 10px;
}
</style>
